module.exports = __webpack_public_path__ + "img/part-1.d8770392.webp";